define('SageDotCom/Components/Unsubscribe',['jquery'], function($) {

    function Unsubscribe(scope) {

    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new Unsubscribe(args);
    }
});
